// 404. Même cadre que les pages légales, deux sorties : l'accueil et les
// guides. `noindex` : Google ne doit pas garder trace d'une URL fautive.
//
// ⚠️ Le statut HTTP reste 200 : un site statique ne sait pas répondre 404
// depuis React. C'est pour ça que la balise noindex est indispensable ici,
// et que `.htaccess` sert la vraie 404 d'Apache pour les fichiers absents.
import { Link } from 'react-router-dom'
import LegalShell from '../components/urself/LegalShell'
import { useT } from '../lib/i18n'

export default function NotFound () {
  const s = useT().seo.notFound

  return (
    <LegalShell title={s.h1} intro={s.p} description={s.description} noindex>
      <p>
        <Link to="/">{s.home}</Link>
        {' · '}
        <Link to="/guides">{s.guides}</Link>
      </p>
    </LegalShell>
  )
}
